import type { Game, HltbTimes as HltbTimesData } from '@/types'

interface HltbBadgeGame {
  hltbTimes?: HltbTimesData
}

export function formatHltbHours(h: number | null | undefined): string | null {
  if (h == null || h <= 0) return null
  if (h < 1) return '<1h'
  return `~${Math.round(h)}h`
}

export function HltbTimePill({ label, hours, url, primary }: { label: string; hours: number; url: string | null | undefined; primary?: boolean }) {
  const inner = (
    <>
      <span className="cg-hltb-time-label">{label}</span>
      <span className="cg-hltb-time-value">{formatHltbHours(hours)}</span>
    </>
  )
  const cls = `cg-hltb-time${primary ? ' cg-hltb-time--primary' : ''}`
  if (url) {
    return (
      <a className={cls} href={url} target="_blank" rel="noopener noreferrer" title={`How Long to Beat — ${label}`}>
        {inner}
      </a>
    )
  }
  return <span className={cls}>{inner}</span>
}

export function HltbTimes({ game }: { game: Game }) {
  if (!game.hltbTimes) return null
  return (
    <div className="cg-meta-row">
      <span className="cg-meta-label">How Long to Beat</span>
      <div className="cg-hltb-times">
        {game.hltbTimes.mainStory && (
          <HltbTimePill label="Main Story" hours={game.hltbTimes.mainStory} url={game.hltbTimes.url} />
        )}
        {game.hltbTimes.mainExtra && (
          <HltbTimePill label="Main + Extras" hours={game.hltbTimes.mainExtra} url={game.hltbTimes.url} primary />
        )}
        {game.hltbTimes.completionist && (
          <HltbTimePill label="Completionist" hours={game.hltbTimes.completionist} url={game.hltbTimes.url} />
        )}
      </div>
    </div>
  )
}

export function HltbBadge({ game }: { game: HltbBadgeGame }) {
  const hours = formatHltbHours(game.hltbTimes?.mainExtra)
  if (!hours) return null
  const label = `⏱ ${hours}`
  const title = 'How Long to Beat — Main + Extras'
  if (game.hltbTimes?.url) {
    return (
      <a
        className="cg-hltb-badge"
        href={game.hltbTimes.url}
        target="_blank"
        rel="noopener noreferrer"
        title={title}
        onClick={(e) => e.stopPropagation()}
      >
        {label}
      </a>
    )
  }
  return <span className="cg-hltb-badge" title={title}>{label}</span>
}
